import axios from 'axios';

  import {
    Configuration,
		LocationAPIsApi,LocationAPIsApiFactory,
		CustomerAPIsApi,CustomerAPIsApiFactory,
		DispatchAPIsApi,DispatchAPIsApiFactory,
		InformationAPIsApi,InformationAPIsApiFactory,
		TAInsuredAmountAPIApi,TAInsuredAmountAPIApiFactory,
		ValidateAPIsApi,ValidateAPIsApiFactory,
		CommonAPIsApi,CommonAPIsApiFactory,
  } from '@fubonlife/tacallindiy-core-axios-sdk';

  declare module 'vue/types/vue' {
    interface Vue {
      $LocationControllerApi:LocationAPIsApi;
			$CustomerControllerApi:CustomerAPIsApi;
			$InformationControllerApi:InformationAPIsApi;
			$CommonControllerApi:CommonAPIsApi;
			$ValidateControllerApi:ValidateAPIsApi;
			$TAInsuredAmountControllerApi:TAInsuredAmountAPIApi;
			$DispatchControllerApi:DispatchAPIsApi;
    }
  }
  export default new (class Api {
    public install(Vue, options: Configuration) {
      Vue.prototype.$LocationControllerApi = LocationAPIsApiFactory(options, process.env.VUE_APP_API_BASE_URL, axios);
			Vue.prototype.$CustomerControllerApi = CustomerAPIsApiFactory(options, process.env.VUE_APP_API_BASE_URL, axios);
			Vue.prototype.$InformationControllerApi = InformationAPIsApiFactory(options, process.env.VUE_APP_API_BASE_URL, axios);
			Vue.prototype.$CommonControllerApi = CommonAPIsApiFactory(options, process.env.VUE_APP_API_BASE_URL, axios);
			Vue.prototype.$ValidateControllerApi = ValidateAPIsApiFactory(options, process.env.VUE_APP_API_BASE_URL, axios);
			Vue.prototype.$TAInsuredAmountControllerApi = TAInsuredAmountAPIApiFactory(options, process.env.VUE_APP_API_BASE_URL, axios);
			Vue.prototype.$DispatchControllerApi = DispatchAPIsApiFactory(options, process.env.VUE_APP_API_BASE_URL, axios);
    }
  })();

